import styled from "styled-components";
import { HXPage } from "../HXDesktopPage";
export const GlobalAdminAgentReleaseEditViewParent = styled(HXPage) ``;
